export enum ORDER_STATUS {
  QUOTE = 'new',
  PUBLISHED = 'published',
  DECLINED = 'declined',
  CLAIMED = 'claimed',
  DISPATCHED = 'dispatched',
  CANCELED = 'canceled',
  PAID = 'paid',
  ON_PICKUP = 'on_pickup',
  ON_WAY_TO_PICKUP = 'on_way_to_pickup',
  PICKED_UP = 'picked_up',
  ON_DELIVERY = 'on_delivery',
  DELIVERED = 'delivered',
  ARCHIVED = 'archived',
  ON_WAY_TO_DELIVERY = 'on_way_to_delivery',
  SIGNATURE_REQUESTED = 'signature_requested',
  DELETED = 'deleted',
  BILLED = 'billed',
  CANCELED_CLIENT = 'canceled-client',
}
